import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

export enum OrchestrationSupportedEntityTypeEnum {
  Integrations = 'Integrations',
  Models = 'Models',
  Exports = 'Exports',
}

@UntilDestroy()
@Injectable()
export class OrchestrationTablesPickerPopupService {
  private readonly activeAssetType$$ = new BehaviorSubject<OrchestrationSupportedEntityTypeEnum>(
    OrchestrationSupportedEntityTypeEnum.Integrations,
  );

  private readonly integrationPaths$$ = new BehaviorSubject<string[]>([]);
  private readonly modelPaths$$ = new BehaviorSubject<string[]>([]);
  private readonly exportPaths$$ = new BehaviorSubject<string[]>([]);

  public readonly activeAssetType$ = this.activeAssetType$$.pipe(untilDestroyed(this));
  public readonly integrationPaths$ = this.integrationPaths$$.pipe(untilDestroyed(this));
  public readonly modelPaths$ = this.modelPaths$$.pipe(untilDestroyed(this));
  public readonly exportPaths$ = this.exportPaths$$.pipe(untilDestroyed(this));

  public setActiveAssetType(val: OrchestrationSupportedEntityTypeEnum) {
    this.activeAssetType$$.next(val);
  }

  public getActiveAssetType() {
    return this.activeAssetType$$.value;
  }

  public setSelectedIntegrations(paths: string[]): void {
    this.integrationPaths$$.next(paths);
  }

  public setSelectedModels(paths: string[]): void {
    this.modelPaths$$.next(paths);
  }

  public setSelectedExports(paths: string[]): void {
    this.exportPaths$$.next(paths);
  }
}
